// ----------------------------------------------------------------------
import { FONTSTYPO, HeadingStyles } from "./palette";
const pxToRem = (value) => `${value / 16}rem`;
// ----------------------------------------------------------------------
const FONT_PRIMARY = "Avenir LT W05_35 Light";
// Const FONT_SECONDARY = 'CircularStd, sans-serif'; // Local Font
const typography = Object.assign(Object.assign({ "body1": {
        "fontSize": pxToRem(16),
        "lineHeight": 1.3,
    }, "body2": {
        "fontSize": pxToRem(14),
        "lineHeight": 1.3,
    }, "button": {
        "fontSize": pxToRem(14),
        "fontWeight": 300,
        "lineHeight": 1.3,
        "textTransform": "unset"
    }, "caption": {
        "fontSize": FONTSTYPO.stepMinues1,
        "fontWeight": 650,
        "lineHeight": 1.3,
    }, "fontFamily": FONT_PRIMARY, "fontWeightBold": 700, "fontWeightMedium": 600, "fontWeightRegular": 400 }, HeadingStyles), { "margin": 0, "overline": {
        "fontSize": pxToRem(12),
        "fontWeight": 300,
        "lineHeight": 1.3,
        "textTransform": "uppercase",
    }, "subtitle1": {
        "fontSize": FONTSTYPO.stepMinues1,
        "fontWeight": 850,
        "lineHeight": 1.3,
    }, "subtitle2": {
        "fontSize": FONTSTYPO.stepMinues1,
        "fontWeight": 300,
        "lineHeight": 1.3,
    } });
// eslint-disable-next-line import/no-default-export
export default typography;
